import gql from 'graphql-tag';

import { Mediator } from '@spotahome/soyuz-mediator';

import { COMMON_LOGIN_MODAL } from '../../channels';

const QUERY_FAVORITES = gql`
  query Favorites($locale: String!) {
    favorites(locale: $locale) {
      checked
      city
      currencyIsoCode
      currencyLabel
      currencySymbol
      hasOffer
      id
      isInstantBooking
      photoUrls {
        homecardHidpi
        homecard
      }
      mainPhotoUrl
      photos
      monthlyPrice {
        type
        minimumPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
      firstAvailableDate
      neighborhoodName
      pricePerMonth
      refreshAvailabilitiesDate
      reviews {
        count
        ratingAverage
      }
      roomType
      runnerName
      title
      type
      url
      visited
      aptFeatures
      roomFeatures
      suitFeatures
      allowsPermanentContract
      isBestChoice
      description
      area
      features
      numberOfBathrooms
    }
  }
`;

const QUERY_FAVORITES_ID = gql`
  query Favorites {
    favorites {
      id
    }
  }
`;

const QUERY_IS_FAVORITE = gql`
  query IsFavorite($id: ID!) {
    isFavorite(id: $id)
  }
`;

const triggerTokenError = err => {
  if (err.message === 'GraphQL error: Token expired') {
    Mediator.publish(COMMON_LOGIN_MODAL);
  }
};

export const getFavorites = client => locale =>
  client
    .query({
      query: QUERY_FAVORITES,
      fetchPolicy: 'network-only',
      variables: { locale }
    })
    .catch(triggerTokenError);

export const getFavoritesIds = client => () =>
  client
    .query({
      query: QUERY_FAVORITES_ID,
      fetchPolicy: 'network-only'
    })
    .catch(triggerTokenError);

export const isFavorite = client => id =>
  client
    .query({
      query: QUERY_IS_FAVORITE,
      fetchPolicy: 'network-only',
      variables: { id }
    })
    .catch(triggerTokenError);

export default {
  getFavorites,
  getFavoritesIds,
  isFavorite
};
